import React, { ReactFragment, ReactNode } from "react"

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react"

// Import Swiper styles
import "swiper/css"
import "swiper/css/grid"
import "swiper/css/pagination"
import "swiper/css/navigation"

// import required modules
import { Navigation, Pagination, Autoplay, Grid } from "swiper"

interface SwiperProps {
  children: ReactNode
  className?: string
  childClassName?: string
  slidesPerView?: number | "auto"
  grid?: {
    rows: number
    fill?: "row" | "column"
  }
  spaceBetween?: number
  autoplay?: {
    delay?: number
  }
  speed?: number
  pagination?: boolean
  navigation?: boolean
  breakpoints?: any
  loop?: boolean
  onActiveIndexChange?: (val: any) => void
}

type ElementType =
  | string
  | number
  | React.ReactElement<any, string | React.JSXElementConstructor<any>>
  | React.ReactPortal
  | ReactFragment

const SwiperSlider = (props: SwiperProps) => {
  const {
    children,
    className,
    childClassName,
    slidesPerView = 1,
    grid,
    spaceBetween = 12,
    onActiveIndexChange,
    pagination = true,
    navigation = true,
    speed = 300,
    autoplay,
    breakpoints,
    loop = false,
  } = props
  const elements = React.Children.toArray(children)

  return (
    <Swiper
      autoplay={autoplay}
      slidesPerView={slidesPerView}
      grid={grid}
      className={className}
      pagination={pagination}
      navigation={navigation}
      spaceBetween={spaceBetween}
      speed={speed}
      loop={loop}
      modules={[Grid, Pagination, Navigation, Autoplay]}
      breakpoints={breakpoints}
      onActiveIndexChange={onActiveIndexChange}
    >
      {elements.map((el: ElementType, key) => (
        <SwiperSlide key={key} className={childClassName}>
          {el}
        </SwiperSlide>
      ))}
    </Swiper>
  )
}

export default SwiperSlider
